module.exports = __webpack_public_path__ + "static/img/wechat_customer_service.427ba24e.png";